import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "编辑推荐", href: "#编辑推荐" },
  { label: "每日精选", href: "#每日精选" },
  { label: "秘书严选", href: "#秘书严选" },
  { label: "本月热荐", href: "#本月热荐" },
  { label: "编辑私藏", href: "#编辑私藏" },
  { label: "常见问题", href: "#常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2" onClick={closeMenu}>
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
            <i className="ri-book-2-line" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">小秘漫画网</span>
        </a>

        <ul className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#编辑推荐"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            去逛逛
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <ul className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={closeMenu}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#编辑推荐"
                onClick={closeMenu}
                className="mt-2 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
              >
                去逛逛
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}